export const ENQUEUE_NOTIFICATION_TOAST = 'TOAST_NOTIFICATIONS/ENQUEUE';
export const DEQUEUE_NOTIFICATION_TOAST = 'TOAST_NOTIFICATIONS/DEQUEUE';
export const ADD_TOAST_NOTIFICATION = 'TOAST_NOTIFICATIONS/ADD';
